<template>
  <div class="wf-search-result description no-min-height" :id="`${productIndex + 1}-${item.styleNumber}`" :key="viewMode" v-if="item.colors && item.colors.length>0">
    <div class="custom-control" v-if="isCompare == true" :class="toggleButton? 'search-result-checkbox':''">
      <input
        @click="compareNow(item)"
        type="checkbox"
        class="custom-control-input"
        :disabled="
          getCompareProducts.length > 11 &&
            !getCompareProducts.some(
              el => el.sellingStyleNumber === item.styleNumber
            )
        "
        :checked="
          getCompareProducts.some(
            el => el.sellingStyleNumber === item.styleNumber
          )
        "
        :id="'compareCheckbox-' + item.styleNumber"
      >
      <label
        class="custom-control-label"
        :for="'compareCheckbox-' + item.styleNumber"
      >{{ $resourceString['product.Search.Label.Compare'] }}</label>
    </div>
    <div
      class="swiper-container swiper-wf-product-quick-view"
      v-wf-swiper="{
        parameters: {
          initialSlide: item.colors.findIndex(
            c => c.colorNumber === currentColorNumber
          ),
          allowTouchMove: false
        },
        slideChangeEvent: onSlideChange
      }"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="color in item.colors"
          :key="color.colorNumber"
        >
          <div class="wf-product-quick-view-swatch-slide">
            <a
              class="px-0 w-100 cart-item-model-no"
              :href="
                $helpers.getProductDetailUrl(
                  item.styleNameURL,
                  item.styleNumber,
                  color.colorNumber
                )
              "
              @click="
                redirectToProductDetail($event);
                $gtm.productClickEvent(item, productIndex, selectedFilters, inStock, filterByFaceWeight);
              "
            >
              <div class="wf-product-quick-view-swatch-slide-image">
                <!-- IMPORTANT: Images are not loaded with wf-load-image due to Swiper DOM manipulation conflicts.
                      Revisit this if time permits - 20210402 SK -->
                <img
                  class="image pdp-result-img"
                  @error="handleImageError"
                  :alt="color.colorNumber"
                  :src="
                    viewMode === 'swatch'
                      ? $helpers.getColorThumbnailImageUrl(
                        item.styleNumber,
                        color.colorNumber
                      )
                      : $helpers.getInteractiveRoomSceneImageUrl(
                        item.styleNumber,
                        color.colorNumber,
                        item.roomsceneIds[rngRoom],
                        itemInstallMethodCode,
                        500
                      )
                  "
                >
              </div>
              <div v-if="color.pdqId == '1'" class="wf-product-tile-pdq">
                <span class="png-icon png-icon-icons-symbols--ko-txtpdq" />
              </div>
              <div class="active-color-header position-absolute d-flex flex-column">
                <div class="mt-1"><b>{{ item.styleName }}</b> - {{ item.styleNumber }}</div>
                <div>{{ item.inventoryType }} - {{ item.productTypeDesc }}</div>
                <div v-if="item.collectionName">{{ $resourceString['site.search.collection.result.header']}}: {{ item.collectionName }}</div>
                <div>{{
                  item.colors.length === 1
                    ? item.colors.length + " COLOR"
                    : item.colors.length + " COLORS"
                }} - {{ color.colorName }}</div>
                <!-- <div> -->
                <div
                  v-if="inStock && color.realTimeInventory"
                  class="text-success wf-search-results-details"
                >
                  {{ $resourceString["generic.product.instockavailable"] }}
                  {{ color.realTimeInventory }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div
        class="
          wf-swiper-thumbnails wf-swiper-thumbnails-with-nav-buttons
          d-none
          on-hover-thumbnails
          ml-3 mr-3
        "
        :class="'wf-product-thumbnails-size-' + tileSize"
      >
        <button
          class="wf-swiper-nav-button wf-swiper-nav-button-prev btn btn-full"
          type="button"
        >
          <span
            class="
              png-icon
              png-icon-icons-glyph--ko-chevron-left
              png-size
              arrow-left
              mt-1
            "
            aria-label="Previous color"
          />
        </button>
        <div class="wf-swiper-thumbnails-container">
          <div
            class="wf-swiper-thumbnail"
            v-for="color in item.colors"
            :key="color.colorNumber"
          >
            <a class="cart-item-model-no"
              :href="
                $helpers.getProductDetailUrl(
                  item.styleNameURL,
                  item.styleNumber,
                  color.colorNumber
                )
              "
              @click="$gtm.productClickEvent(item, productIndex, selectedFilters, inStock, filterByFaceWeight)"
            >
              <div class="red-underline" />
              <img
                class="image-thumbnail"
                alt="img"
                @error="handleImageError"
                :src="
                  $helpers.getColorThumbnailImageUrl(
                    item.styleNumber,
                    color.colorNumber
                  )
                "
              >
            </a>
          </div>
        </div>
        <button
          class="wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full"
          type="button"
        >
          <span
            class="
              png-icon
              png-icon-icons-glyph--ko-chevron-right
              arrow-right
              png-size
              mt-1
            "
            aria-label="Next color"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { globalIcons } from "../../../constants/global";
export default {
  props: ["item", "productIndex", "isCompare",'toggleButton'],
  data() {
    return {
      currentColorNumber: this.item?.colors[0]?.colorNumber,
      itemInstallMethodCode: this.item?.installationMethods[0]?.name || "1",
      rngRoom: Math.floor(Math.random() * this.item?.roomsceneIds?.length),
      cachedProducts: [],
      sharedCompareProducts: "filters/sharedCompareProducts",
      defaultImage:globalIcons.defaultImage
    };
  },
  methods: {
    ...mapActions({
      fetchCompareProducts: "productDetail/fetchCompareProducts",
      removeCompareProducts: "productDetail/removeCompareProducts"
    }),

    handleImageError(event) {
      $(`.swiper-slide-duplicate img[src="${event.target.src}"]`).attr("src", this.defaultImage);
      event.target.src = this.defaultImage;
    },

    redirectToProductDetail: function (e) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        window.location.href =
          e.target.parentNode.parentNode.attributes.href.value ||
          e.currentTarget?.getAttribute("href");
      }, 50);
    },
    compareNow: function (value) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        let products = this.getCompareProducts;
        const result = products.findIndex(
          ({ sellingStyleNumber }) => sellingStyleNumber === value.styleNumber
        );
        if (result < 0 && this.getCompareProducts.length < 12) {
          this.fetchCompareProducts(value.styleNumber);
        } else if (result > -1) {
          this.removeCompareProducts(value.styleNumber);
        }
      }, 200);
    },
    onSlideChange: function (swiper) {
      // On slide change, update the selected color
      if (this.item.colors) {
        const slideIndex = swiper.realIndex;
        const colorNumber = this.item.colors[slideIndex].colorNumber;
        this.setCurrentColorNumber(colorNumber);
      }
    },
    setCurrentColorNumber(colorNumber) {
      this.currentColorNumber = colorNumber;
    },
    setProductIdUrlParam(styleNum, id) {
      const url = new URL(window.location);
      url.searchParams.set("ProductId", `${id}-${styleNum}`);
      window.history.pushState({}, "", url);
    },
    parseStyleFromImageUrl(imageUrl) {
      const parts = imageUrl.split('/');
      const parsedStyleNumber = parts[parts.length - 4];
      return parsedStyleNumber;
    },
    trackClickedProductInUrl() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      if (urlSearchParams.has('searchTerm')) return;

      let products = document.getElementsByClassName("wf-search-result description");
      if (products.length > 0) {
        for (let i = 0; i < products.length; i++) {
          let imageUrl = products[i].querySelector('.image')?.getAttribute('src');
          products[i].addEventListener("click", () => {
            this.setProductIdUrlParam(this.parseStyleFromImageUrl(imageUrl), i + 1);
          });
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      tileSize: "filters/tileSize",
      viewMode: "filters/viewMode",
      inStock: "filters/inStock",
      searchTerm: "searchResultsPage/searchTerm",
      getCompareProducts: "productDetail/getCompareProducts",
      selectedFilters: "filters/selectedFilters",
      filterByFaceWeight: "filters/filterByFaceWeight",
    })
  },
  mounted() {
    this.setCurrentColorNumber(this.item?.colors[0]?.colorNumber);
    this.trackClickedProductInUrl();
  }
};
</script>

<style></style>
